export default "__VITE_ASSET__B5Cf6hhs__"